import React, { useEffect, useState } from 'react';
import ArrowButton, {
  ArrowButtonStyle,
  ArrowDirection,
} from '@/components/navigation/ArrowButton';

const HeroSection = ({ children }: { children: JSX.Element }) => {
  return (
    <div className="relative z-[1] flex h-[calc(100dvh)] flex-col items-center justify-center pb-[50px]">
      {children}
    </div>
  );
};

const ContentSection = ({ children }: { children: JSX.Element }) => {
  // calculating iconOffset not working on deployed instance, will investigate but pushing to avoid blocking dev
  const [, setIconOffset] = useState(20);

  const handleClick = (value: string) => {
    const element = document.getElementById(value);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    // Recalculating height to ensure we're always updating half of the icon height if the height changes
    const iconHeight = document.getElementById('icon')?.offsetHeight;
    setIconOffset((iconHeight ?? 40) / 2);
  }, []);

  return (
    <div
      className="relative z-[2] mx-auto -mt-[37px] flex w-full flex-col items-center justify-center rounded-t-3xl bg-white"
      id="content"
    >
      <div
        className={'-mt-[20px] justify-center'}
        onClick={() => handleClick('content')}
        id={'icon'}
      >
        <ArrowButton
          direction={ArrowDirection.down}
          style={ArrowButtonStyle.dark}
          classes="mx-auto"
        />
      </div>
      <div className="w-full pt-[100px]">{children}</div>
    </div>
  );
};

const HeroComponent = ({
  heroSection,
  content,
}: {
  heroSection: JSX.Element;
  content: JSX.Element;
}) => {
  return (
    <div className="top-0 w-full">
      <HeroSection>{heroSection}</HeroSection>
      <ContentSection>{content}</ContentSection>
    </div>
  );
};

export default HeroComponent;
